import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/error-log/page';

export const Route = createFileRoute('/_app/settings/error-log/')({
  component: Page,
});
